import { CrmProductRow, DeckProductContext } from './deck-admin.models';

/**
 * Product-resolution helpers shared by the deck board and the agent-prompt tab.
 *
 * Both tabs are scoped to the CRM's globally-selected product (sidebar). Each
 * resolves that selection the same way — match the selected cuid against the
 * product list, falling back to the first product — so the logic lives here once
 * instead of being duplicated per tab.
 */

/** Resolve the globally-selected product to a row, falling back to the first available. */
export function resolveProductRow(
  products: CrmProductRow[],
  selectedId: string | null
): CrmProductRow | null {
  if (selectedId) {
    const match = products.find((p) => String(p.id) === String(selectedId));
    if (match) return match;
  }
  return products[0] ?? null;
}

/** Stable identity for a product scope, used to skip redundant reloads. */
export function productStamp(product: CrmProductRow | null): string {
  return `${product?.keyname ?? ''}|${product?.pid ?? ''}`;
}

/** Build the API product scope (keyname + pid) from a resolved product row. */
export function toProductContext(product: CrmProductRow | null): DeckProductContext {
  return {
    productKey: product?.keyname ?? null,
    productPid: product?.pid ?? null,
  };
}
